import {
  MenuItem as MuiMenuItem, MenuItemProps,
} from '@mui/material';

export const MenuItem = (props: MenuItemProps & { testId?: string; 'data-testid'?: string }) => (
  <MuiMenuItem {...props} data-testid={props['data-testid'] || props.testId} />
);
